var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SimpleStackedChart',{attrs:{"name":_vm.$t('Chart__NumberOfDiplomas__name'),"sheets":_vm.sheets}},[_c('p',{staticClass:"fmhind-graph-number-of-diplomas__source"},[_vm._v(" "+_vm._s(_vm.$t('Chart__NumberOfDiplomas__source'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }